import React, {useEffect, useRef, useState} from 'react';
import {
    findPendingSalesByTableId,
    findProductsByQueryString,
    getTableById
} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate, useParams} from "react-router-dom";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import {makeRequest} from "../../utils/httpRequest";

const apiUrl = Config.apiUrl;
const FinishTableItems = () => {

    const {tableId} = useParams();

    const [table, setTable] = useState(null);
    const [sales, setSales] = useState([]);

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const [totalValue, setTotalValue] = useState(undefined);

    // Recalcula a cada mudança de quantidade (botões - e +), não só ao carregar a mesa.
    useEffect(() => {
        const newTotalValue = products.reduce((accumulator, currentProduct) => {
            const quantity = currentProduct.quantity ?? 0;
            if (quantity > 0 || quantity < 0) {
                return accumulator + (currentProduct.salePrice * quantity);
            }
            return accumulator;
        }, 0);
        setTotalValue(newTotalValue);
    }, [products]);

    async function makeQuery() {
        try {
            setLoading(true);
            const [fetchedTable, pendingSales, catalog] = await Promise.all([
                getTableById(tableId),
                findPendingSalesByTableId(tableId),
                findProductsByQueryString('')
            ]);

            const productQuantities = {};

            (pendingSales || []).forEach(sale => {
                sale.saleItems.forEach(item => {
                    const key = item.product.id + (item.productName !== undefined ? item.productName : '');
                    if (productQuantities[key]) {
                        productQuantities[key].quantity += item.quantity;
                    } else {
                        productQuantities[key] = {
                            id: item.product.id,
                            productName: item.productName,
                            salePrice: item.product.salePrice,
                            quantity: item.quantity
                        };
                    }
                });
            });

            catalog.forEach((item, index) => {
                if (!productQuantities[item.id + item.name]) {
                    productQuantities[item.id + item.name] = {
                        id: item.id,
                        productName: item.name,
                        salePrice: item.salePrice,
                        quantity: 0,
                        order: index
                    };
                }
            });

            let productList = Object.values(productQuantities).map((productQuantity) => ({
                id: productQuantity.id,
                companyId: 0,
                code: 0,
                name: productQuantity.productName,
                salePrice: productQuantity.salePrice,
                category: '',
                quantity: productQuantity.quantity,
                order: productQuantity.order
            }));

            productList = productList.sort((a, b) => {
                if (a.order < b.order) return -1;
                if (a.order > b.order) return 1;
                return 0;
            });

            let newProductList = productList.filter(p => p.quantity > 0 || p.quantity < 0);
            newProductList = newProductList.concat(productList.filter(p => p.quantity === undefined || p.quantity === 0));

            setTable(fetchedTable);
            setSales(pendingSales || []);
            setProducts(JSON.parse(JSON.stringify(newProductList)));
            setFilteredProducts(JSON.parse(JSON.stringify(newProductList)));
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [tableId]);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    const handleInputChange = (e) => {
        let string = removeSpecialChars(e.target.value).toUpperCase();
        setQueryString(string);
    };
    useEffect(() => {
        const filtered = products.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(queryString));
        setFilteredProducts(JSON.parse(JSON.stringify(filtered)));
    }, [queryString, products]);

    const onConfirmClick = () => {
        if (sales.length === 0) {
            alert('Nenhum pedido pendente para esta mesa.');
            return;
        }

        const salesId = sales.map(s => s.id);

        const saleItems = products
            .filter((p) => p.quantity > 0)
            .map((p) => ({product: {id: p.id, salePrice: p.salePrice}, productName: p.name, quantity: p.quantity}));

        const sale = {table, saleItems};

        localStorage.setItem('saleClosing', JSON.stringify({
            mode: 'table',
            salesId,
            sale,
            totalValue
        }));

        navigate('/sale/payment');
    };

    const doPrint = async () => {
        if (sales.length === 0) {
            alert('Nenhum pedido pendente para esta mesa.');
            return;
        }

        const userUUID = Cookies.get('userUUID');
        const salesId = sales.map(s => s.id);

        const urlPay = apiUrl + '/api/sales/print-bill';
        await makeRequest(urlPay, 'PUT', {
            'Content-Type': 'application/json',
            'Useruuid': userUUID,
        }, JSON.stringify(salesId));
    };

    const onPrint = async () => {
        setLoading(true);
        await doPrint();
        setLoading(false);
    }

    if (!table) {
        return null;
    }

    return (
        <>
            <div className="header-label">Fechar Mesa - {table.name}</div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(event) => event.target.select()}/>
                <button id="clearButton" onClick={() => {
                    setQueryString('');
                    inputQueryString.current.focus();
                }}>X
                </button>
            </div>
            <div className="scrollable-table-area">
            <table style={{width: '100%'}}>
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Preço</th>
                    <th/>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {filteredProducts.map((product, index) => (
                    <tr key={index} style={{backgroundColor: product.quantity > 0 ? 'var(--warning-color)' : product.quantity < 0 ? 'var(--error-color)' : 'white'}}>
                        <td>
                            <div key={index}>{product.name}</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'right'}}>{product.salePrice.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                            </div>
                        </td>
                        <td>
                            <button className="remove-button" onClick={async () => {
                                setProducts((prevItems) =>
                                    prevItems.map((item) =>
                                        item.id === product.id && (!item.name || item.name === product.name) ? {
                                            ...item,
                                            quantity: (item.quantity ? item.quantity : 0) - 1,
                                        } : item
                                    )
                                );
                                setFilteredProducts((prevItems) =>
                                    prevItems.map((item, i) =>
                                        i === index ? {
                                            ...item,
                                            quantity: (item.quantity ? item.quantity : 0) - 1,
                                        } : item
                                    )
                                );
                            }}>-
                            </button>
                        </td>
                        <td>
                            {product.quantity ? product.quantity : 0}
                        </td>
                        <td>
                            <button onClick={async () => {
                                setProducts((prevItems) =>
                                    prevItems.map((item) =>
                                        item.id === product.id && (!item.name || item.name === product.name) ? {
                                            ...item,
                                            quantity: (item.quantity ? item.quantity : 0) + 1,
                                        } : item
                                    )
                                );
                                setFilteredProducts((prevItems) =>
                                    prevItems.map((item, i) =>
                                        i === index ? {
                                            ...item,
                                            quantity: (item.quantity ? item.quantity : 0) + 1,
                                        } : item
                                    )
                                );
                            }}>+
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
                {filteredProducts.length === 0 &&
                    <tfoot>
                    <tr>
                        <td colSpan={5}>
                            Nenhum item encontrado
                        </td>
                    </tr>
                    </tfoot>
                }
            </table>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div className="total-label" style={{textAlign: 'right', fontSize: '30px', color: '#cc5545'}}>Valor
                    Total:
                    R$ {(totalValue !== undefined ? totalValue : 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                </div>
            </div>
            <ActionButtonsManagerView>
                <button onClick={onPrint} disabled={loading}>Imprimir</button>
                <button onClick={onConfirmClick} disabled={loading}>Confirmar</button>
            </ActionButtonsManagerView>
        </>
    );
}

export default FinishTableItems;
